@if (isSideNavEnabled) {
<mat-list class="d-flex flex-column nav-mat-list position-relative">
  <button
    type="button"
    class="no-button arrow-btns sidebar-toggle-btn"
    (click)="toggleNavbar()"
    [attr.aria-label]="navIsExpanded ? 'Collapse sidebar' : 'Expand sidebar'">
    <mat-icon class="sidebar-toggle-icon" aria-hidden="true">{{ navIsExpanded ? 'chevron_left' : 'chevron_right' }}</mat-icon>
  </button>

  <mat-list-item class="nav-list-item nav-header" [ngClass]="navIsExpanded ? 'expaned-nav': 'collapsed-nav'">
    <div class="d-flex justify-content-between w-100">
      <div class="logo">
        <img [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="CVA logo" width="70px" />
      </div>
    </div>
  </mat-list-item>

  <mat-divider></mat-divider>

  <div class="scrollable-list">
    <mat-list-item class="nav-list-item" [ngClass]="navIsExpanded ? 'expaned-nav': 'collapsed-nav'">
      <div class="d-flex mat-list-item" [ngClass]="!navIsExpanded ? 'text-center icons-center-colapse' : ''">

        @if (navIsExpanded) {
        <mat-icon>person_outline</mat-icon>
        <span class="ms-1 family-SFPro user-name"
          [matTooltip]="(practitionerService.loggedInPractitioner?.firstName || '') + ' ' + (practitionerService.loggedInPractitioner?.lastName || '')">{{practitionerService.loggedInPractitioner?.firstName
          || ""}} {{practitionerService.loggedInPractitioner?.lastName || ""}}</span>
        <mat-icon [matMenuTriggerFor]="userMenu" class="pointer">keyboard_arrow_down</mat-icon>
        <mat-menu #userMenu="matMenu" xPosition="after" class="user-menu-expanded">
          <cva-side-nav-user-menu-items></cva-side-nav-user-menu-items>
        </mat-menu>
        }@else {
        <mat-icon [matMenuTriggerFor]="userMenu" class="pointer">person_outline</mat-icon>
        <mat-menu #userMenu="matMenu" xPosition="after" class="user-menu-collapse">
          <cva-side-nav-user-menu-items></cva-side-nav-user-menu-items>
        </mat-menu>
        }
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>

    @for (scope of appScopes; track $index) {
    <mat-list-item aria-hidden="true" (click)="onClickNavButton(scope)" onKeyDown="doNothing();"
      tabindex="0" class="d-flex nav-list-item nav-scope"
      [ngClass]="(navIsExpanded ? 'expaned-nav ' : 'collapsed-nav ') + (activeRoute===scope.route ? 'active-route' : '')"
      cvaAuthPermCheck [moduleName]='AUTH_MODULE_ROUTE_MAP[scope.route.replaceAll("/", "")]'
      [permissionType]='CVA_CONSTANTS.PERMISSION.READ' [actionType]='"hide"'>
      <div class="mat-list-item d-flex" [ngClass]="!navIsExpanded ? 'text-center icons-center-colapse' : ''">
        <mat-icon [ngClass]="activeRoute === scope.route ? 'active-route-icon':''">{{ scope.icon }}</mat-icon>
        @if (navIsExpanded) {
        <span class="ms-1 family-SFPro navHeadings user-name" pointer-events-none
          [ngClass]="activeRoute === scope.route ? 'active-route-icon':''">{{scope.title}}</span>
        }
      </div>
    </mat-list-item>
    <mat-divider cvaAuthPermCheck [moduleName]='AUTH_MODULE_ROUTE_MAP[scope.route.replaceAll("/", "")]'
      [permissionType]='CVA_CONSTANTS.PERMISSION.READ' [actionType]='"hide"'></mat-divider>
    }


  </div>
</mat-list>
}